import s from './table-referral-card.module.scss'
import { IconInfoCircle } from '@tabler/icons-react'
import { queryClient } from '@shared/api/query-client'
import { TZDate } from '@date-fns/tz'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import useMedia from 'use-media'
import classNames from 'classnames'

const STATUS = {
  activated: { label: 'Активный', className: 'success' },
  pending: { label: 'Ожидает', className: 'pending' },
  expired: { label: 'Истёк', className: 'expired' },
}

const getAvatarUrl = (avatar) => {
  if (!avatar) return null
  if (typeof avatar === 'string') return process.env.REACT_APP_STORAGE_URL + avatar
  return avatar?.image ? process.env.REACT_APP_STORAGE_URL + avatar.image : null
}

export const TableReferralCard = ({referral}) => {

  const {data: profile} = queryClient.getQueryData(['profile'])

  const status = STATUS[referral?.status] ?? STATUS.pending

  const defaultAvatar = process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'
  const avatarSrc = getAvatarUrl(referral?.referred?.avatar) || defaultAvatar
  const onImgError = (e) => { e.currentTarget.onerror = null; e.currentTarget.src = defaultAvatar }

  const date = referral?.activated_at ? new TZDate(referral?.activated_at, profile?.timezone) : null

  const isMobile = useMedia({maxWidth: '768px'})


  return (
    <tr className={s.card}>
      {isMobile ?
        <>
        <div className={s.mainInfo}>
          <div className={s.teacherInfo}>
              <img src={avatarSrc} onError={onImgError} alt="" />
              <div className={s.teacherText}>
                <span className={s.teacher}>Преподаватель</span>
                <h2 className={s.teacherName}>{referral?.referred?.name}</h2>
              </div>
          </div>
            <div className={classNames(s.textAndStatus, s[status.className])}>
                <span className={s.indicator}></span>
                <span className={s.statusText}>{status.label}</span>
            </div>
        </div>
        <div className={s.dateInfo}>
          <span className={s.text}>Дата записи</span>
          <span className={s.date}>{date ? format(date, 'dd MMMM yyyy', {locale: ru}) : '-'}</span>
        </div>
        </>

      :

      <>
        <td data-label="Дата">
          <div className={s.td}>
              <span>
                  {date ? format(date, 'dd MMMM yyyy', {locale: ru}) : '-'}
              </span>
          </div>
        </td>

        <td data-label="Преподаватель">
          <div className={s.td}>
            <div className={s.teacher}>
              <img src={avatarSrc} onError={onImgError} alt="" />
              <span>{referral?.referred?.name}</span>
            </div>
          </div>
        </td>

        <td data-label="Статус">
          <div className={`${s.td} ${s.status}`}>
              <div className={classNames(s.textAndStatus, s[status.className])}>
                  <span className={s.indicator}></span>
                  <span className={s.statusText}>{status.label}</span>
              </div>
              <button>
                  <IconInfoCircle stroke={1} size={20}/>
              </button>
          </div>
        </td>
      </>
      }
    </tr>
  )
}
